import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { NotificationState } from './notification.reducers';

export const selectNotificationState = (state: AppState) => state.notifications;

// ─── Unread Count ────────────────────────────────────────────────────────────

export const selectUnreadCount = createSelector(
  selectNotificationState,
  (state: NotificationState) => state.unreadCount
);

// ─── Notifications List ──────────────────────────────────────────────────────

export const selectNotifications = createSelector(
  selectNotificationState,
  (state: NotificationState) => state.notifications
);

// ─── Loading ─────────────────────────────────────────────────────────────────

export const selectNotificationsLoading = createSelector(
  selectNotificationState,
  (state: NotificationState) => state.loading
);

// ─── Loaded ──────────────────────────────────────────────────────────────────

